const intervalId = setInterval(() => {
    if (window.tlDiscounts) {
        const widgetContainer = document.querySelector(".tl-discount-tier-container");

        if (!widgetContainer) return;

        window.tlDiscounts.discountsGroup.forEach((discount) => {
            if (discount.layout_type === "allow_interact") return;

            const productPrice = Number(window.tlDiscounts.product.priceMax) || 0;

            discount.discountTiers.forEach((tier) => {
                const tierDiscountedPriceElement = widgetContainer.querySelector(
                    `.tl-discounts-total-price-${discount.id}-tier-${tier.id}.tl-discount-tier-price`,
                );
                const tierRegularPriceElement = widgetContainer.querySelector(
                    `.tl-discounts-total-del-price-${discount.id}-tier-${tier.id}.tl-discount-tier-regular-price`,
                );

                const totalPrice =
                    discount.value_type === "percentage"
                        ? (productPrice * (100 - tier.off)) / 100
                        : Math.max(0, productPrice - Number(tier.off) * 100 * window.tlDiscounts.currencyRate);
                tierDiscountedPriceElement.innerHTML = window.tlDiscounts.formatMoney(totalPrice);
                tierRegularPriceElement.innerHTML = window.tlDiscounts.formatMoney(productPrice);
            });
        });

        clearInterval(intervalId);
        console.log("Customization done!");
    }
}, 50);
setTimeout(() => clearInterval(intervalId), 3000);